import { EventEmitter } from "../util/eventemitter";
import { QF } from "./luaquestfuncs";
import { ConversationState } from "./conversationstate";
import { ConConversationState } from "./conversationstate-con";
import { LuaFunctions } from "./luafuncs";
import { GF } from "./luagamefuncs";

export class Conversation extends EventEmitter {
    _state: any;
    _luaState: any;
    npc: any;
    message: string;
    options: any;
    dialog: any;
    _isOriginalCon: boolean;

    constructor(npcObj: any, spec: any, lang: any) {
        super();

        this._isOriginalCon = Array.isArray(spec.dialogBlocks);
        this._luaState = null;

        if (spec.luaDataIsBytecode) {
            throw new Error("Conversation runtime accepts Lua source only");
        }
        this._luaState = eval(lua_load(spec.luaData || ""))();
        LuaFunctions.init(this._luaState);

        if (this._isOriginalCon) {
            this._state = new ConConversationState(
                spec,
                lang,
                this._evaluateConCondition.bind(this),
                this._runConAction.bind(this),
            );
        } else {
            this._state = new ConversationState(spec, lang);
        }

        this.npc = npcObj;
        if (npcObj) {
            MC.quests.refNpc = npcObj.charIdx;
        }
        this.message = "";
        this.options = {};
        this.dialog = null;
    }

    start() {
        if (this._isOriginalCon) {
            this._state.start();
            this._syncOriginalConState();
            return;
        }
        this._go();
    }

    end() {
        this.emit("closed");
    }

    pickOption(optionId: any) {
        if (this._isOriginalCon) {
            this._state.pickOption(optionId);
            this._syncOriginalConState();
            return;
        }
        this._state.condValue = optionId;
        this._go();
    }

    _evaluateConCondition(functionName: string): boolean | undefined {
        if (!this._luaState) return undefined;
        const result = lua_tablegetcall(this._luaState, functionName, [this]);
        return Number(result[0]) >= 1;
    }

    _runConAction(functionName: string): any {
        if (this._luaState) {
            const result = lua_tablegetcall(this._luaState, functionName, [this]);
            return result[0];
        }
        return undefined;
    }

    _syncOriginalConState(): void {
        if (this._state.closed) {
            this.end();
            return;
        }
        this.message = this._formatString(this._state.message);
        this.options = {};
        for (const optionId in this._state.options) {
            this.options[optionId] = this._formatString(
                this._state.options[optionId],
            );
        }
        this._showDialog();
    }

    _formatString(string: any) {
        const search = /<[A-Z_]*>/g;
        let match;

        while ((match = search.exec(string))) {
            const prefix = string.substr(0, match.index);
            const suffix = string.substr(match.index + match[0].length);
            let content = match[0].substr(1, match[0].length - 2);

            // https://github.com/brett19/RoseOnlineEvo/blob/master/Game/Client/Event/CEvent.cpp#L553-L585
            if (content === "NAME") {
                content = MC.name;
            } else if (content === "LEVEL") {
                content = MC.level;
            } else if (content === "REVIVE_ZONE") {
                content = GF.getReviveZoneName()[0];
            } else {
                content = match[0];
            }

            string = prefix + content + suffix;
        }

        return string;
    }

    _showDialog() {
        if (!this.dialog) {
            this.dialog = ui.npcChatDialog(this);
        } else {
            this.emit("changed");
        }
    }

    _go() {
        let running = true;
        while (running) {
            const reqval = this._state.exec();

            switch (reqval) {
                case CXECURREQ.CLOSE:
                    this.end();
                    running = false;
                    break;
                case CXECURREQ.OPTCONDITION:
                    this.message = this._formatString(this._state.message);
                    this.options = this._state.options;

                    for (let key in this.options) {
                        this.options[key] = this._formatString(this.options[key]);
                    }

                    this._showDialog();
                    running = false;
                    break;
                case CXECURREQ.LUACONDITION:
                    let luaResult = lua_tablegetcall(
                        this._luaState,
                        this._state.condParam,
                        [this]
                    );
                    this._state.condValue = luaResult[0];
                    break;
                case CXECURREQ.LUAACTION:
                    lua_tablegetcall(this._luaState, this._state.condParam, [
                        this,
                    ]);
                    break;
                case CXECURREQ.QSDCONDITION:
                    const qsdResult = QF.checkQuestCondition(
                        this._state.condParam
                    );
                    this._state.condValue = qsdResult[0];
                    break;
                case CXECURREQ.QSDACTION:
                    QF.doQuestTrigger(this._state.condParam);
                    break;
                default:
                    console.warn(
                        "Received unknown request from ConversationState."
                    );
                    running = false;
            }
        }
    }
}
